export var WalletTypeEnum;
(function (WalletTypeEnum) {
    WalletTypeEnum["Wif"] = "wif";
    WalletTypeEnum["Seed"] = "seed";
    WalletTypeEnum["Hd"] = "hd";
    WalletTypeEnum["Watch"] = "watch";
    WalletTypeEnum["PrivateKey"] = "privkey";
})(WalletTypeEnum || (WalletTypeEnum = {}));
export var FeePaidByEnum;
(function (FeePaidByEnum) {
    FeePaidByEnum["change"] = "change";
    FeePaidByEnum["first"] = "firstOutput";
    FeePaidByEnum["any"] = "anyOutputs";
    FeePaidByEnum["last"] = "lastOutput";
    FeePaidByEnum["changeThenFirst"] = "changeThenFirst";
    FeePaidByEnum["changeThenAny"] = "changeThenAny";
    FeePaidByEnum["changeThenLast"] = "changeThenLast";
})(FeePaidByEnum || (FeePaidByEnum = {}));
//# sourceMappingURL=enum.js.map